import { call, put, takeEvery } from 'redux-saga/effects';
import { dpNewsFeedActionCreators, DpNewsFeedActionKeys, FetchDpNewsFeedPost, IDpNewsFeedPost } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { uiActionCreators } from '../../ui';
import { fetchDpNewsFeedPost } from '../dpNewsFeedApi';

function* fetchDpNewsFeedPostSaga(action: FetchDpNewsFeedPost) {
  yield put(uiActionCreators.showFullPageLoading());
  const response: IApiExecuteRespone<IDpNewsFeedPost> = yield call(fetchDpNewsFeedPost, action.payload.postId);

  if (!response.requestFailed) {
    yield put(uiActionCreators.hideFullPageLoading());
    if (response.value) {
      yield put(dpNewsFeedActionCreators.setPosts([response.value]));
    }
  } else {
    // TODO - show error message
  }
}

export function* watchFetchDpNewsFeedPost() {
  yield takeEvery(DpNewsFeedActionKeys.FETCH_DP_NEWS_FEED_POST, fetchDpNewsFeedPostSaga);
}
